// @flow strict

import type { Group } from '@ansarada/ace-react/dist/ace/components/Select2/Select2.types';
import * as React from 'react';
import { Button, Select2 } from '@ansarada/ace-react';
import OnBoardingLayout from '../OnBoardingLayout';

type PropsType = {|
  title: string,
  onBack: () => void,
  onNext: () => void,
  value: string,
  onChange: string => void,
  placeholder: string,
  questionOptions: Array<Group>,
  bgMobile: string,
  bgDesktop: string,
|};

const Question1Space = (props: PropsType) => {
  const { title, onBack, onNext, value, onChange, placeholder, questionOptions } = props;
  return (
    <OnBoardingLayout
      title={title}
      actionButtons={[
        <Button onClick={onBack} key="back" id="s4-back">
          Back
        </Button>,
        <Button onClick={onNext} key="next" variant="Primary" disabled={!value} id="s4-next">
          Next
        </Button>,
      ]}
      bgMobile={props.bgMobile}
      bgDesktop={props.bgDesktop}
    >
      <Select2
        size="Medium"
        placeholder={placeholder}
        value={value}
        options={questionOptions}
        onChange={option => onChange(option.value)}
        id="s4-work-area"
      />
    </OnBoardingLayout>
  );
};

export default Question1Space;
